// Ashwick quest hint locations (world XZ). Mill/grave/page match AshwickTown;
// villager waypoints match first AshwickNPCs day posts (MX = -30, MZ = -500).
export const ASHWICK_MILL = { x: 0, z: -500 };
export const ASHWICK_GRAVE = { x: 80, z: -500 };
export const ASHWICK_PAGE = { x: 82, z: -498 };
export const ASHWICK_QUEST_CAVE = { x: 200, z: -500 };

/** Nearest-day posts for the three named villagers (quest step "villagers"). */
export const ASHWICK_VILLAGER_POSTS = [
  { key: 'maren', x: -37, z: -500 },
  { key: 'dov', x: -20, z: -522 },
  { key: 'sera', x: -23, z: -507 },
];
